import { render, staticRenderFns } from "./RegPopup.vue?vue&type=template&id=56f1052c&scoped=true"
import script from "./RegPopup.vue?vue&type=script&lang=js"
export * from "./RegPopup.vue?vue&type=script&lang=js"
import style0 from "./RegPopup.vue?vue&type=style&index=0&id=56f1052c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1052c",
  null
  
)

export default component.exports